// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { httpBodyToProductData } from '../../product-data';
import {
  BestPerformingArticlesProviderArgs,
  BestPerformingArticlesProviderConfigArgs,
} from '../../types/best-performing-articles-provider';

export function getDataForBestPerformingArticles(
  panelNameProvider: IDynamicBindableValue,
  brandOrganisationIdProvider: IDynamicBindableValue,
  bestPerformingArticlesProvidersArgsProvider: IDynamicBindableValue,
): IDynamicBindableValue {
  return {
    provider: 'HttpBodyProvider',
    property: {
      values: [
        panelNameProvider,
        brandOrganisationIdProvider,
        bestPerformingArticlesProvidersArgsProvider,
      ],
      transform: function (args: unknown): string {
        const [panelName, brandOrg, bestPerformingArticlesProvidersArgs] =
          args as [string, string, BestPerformingArticlesProviderConfigArgs];

        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(
          toDate.getDate() - bestPerformingArticlesProvidersArgs.numberOfDays,
        );

        const orderTypeStr = bestPerformingArticlesProvidersArgs.orderType;
        let orderType: number | undefined;
        if (orderTypeStr === 'reorder') {
          orderType = 0;
        } else if (orderTypeStr === 'preorder') {
          orderType = 1;
        }
        if (orderType === undefined) {
          throw new Error(
            `Order type '${orderTypeStr}' was not translated to an equivalent number.`,
          );
        }

        const properties: BestPerformingArticlesProviderArgs = {
          brandOrg,
          orderType:
            bestPerformingArticlesProvidersArgs.orderType === 'reorder' ? 0 : 1,
          productsAmount: bestPerformingArticlesProvidersArgs.productsAmount,
          // sortBy: bestPerformingArticlesProvidersArgs.sortBy, // Does not seem to work, even though it is documented. Max said this is due to some default being set up for the provider in console.
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
        };

        if (bestPerformingArticlesProvidersArgs.category !== null) {
          properties.category = bestPerformingArticlesProvidersArgs.category;
        }

        const body = {
          panelType: panelName,
          properties,
        };

        const fetchString =
          window.neoclesDynamicFramework.recommendationsPanels.methods.createHttpRequestFetchString(
            '/api/v2/recommendation/suggest',
            'POST',
            body,
          );

        return fetchString;
      }.toString(),
    },
    transform: httpBodyToProductData.toString(),
    wrapWithLoadingState: true,
  };
}
